export const SIDE_BET_INDICATOR_STATUS = {
  NONE: 'NONE',
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  RESOLVED: 'RESOLVED',
};

export const getSideBetIndicator = (challenge) => {
  const status = challenge?.sideBetIndicatorStatus || SIDE_BET_INDICATOR_STATUS.NONE;
  const count = Number(challenge?.sideBetCount || 0);
  const pendingCount = Number(challenge?.currentUserPendingSideBetCount || 0);
  const chosenCount = Number(challenge?.currentUserSideBetChoiceCount || 0);

  if (status === SIDE_BET_INDICATOR_STATUS.NONE || count <= 0) {
    return null;
  }

  if (status === SIDE_BET_INDICATOR_STATUS.PENDING || pendingCount > 0) {
    return {
      status: SIDE_BET_INDICATOR_STATUS.PENDING,
      label: pendingCount > 1 ? `Особые исходы: выбрать ${pendingCount}` : 'Особый исход ждёт выбора',
      title: pendingCount > 1
        ? `Есть ${pendingCount} особых исхода без вашего выбора`
        : 'Есть особый исход без вашего выбора',
      accent: 'var(--bm-accent-red)',
      background: 'rgba(255, 84, 84, 0.12)',
      border: 'rgba(255, 84, 84, 0.35)',
    };
  }

  if (status === SIDE_BET_INDICATOR_STATUS.RESOLVED) {
    return {
      status: SIDE_BET_INDICATOR_STATUS.RESOLVED,
      label: count > 1 ? `Особые исходы завершены: ${count}` : 'Особый исход завершён',
      title: count > 1 ? `В пари ${count} завершённых особых исходов` : 'Особый исход завершён',
      accent: 'var(--bm-text-muted)',
      background: 'rgba(148, 163, 184, 0.12)',
      border: 'rgba(148, 163, 184, 0.3)',
    };
  }

  return {
    status: SIDE_BET_INDICATOR_STATUS.COMPLETED,
    label: count > 1 ? `Особые исходы выбраны: ${chosenCount}/${count}` : 'Особый исход выбран',
    title: count > 1
      ? `Вы выбрали варианты во всех особых исходах: ${chosenCount}/${count}`
      : 'Вы выбрали вариант в особом исходе',
    accent: 'var(--bm-accent-green)',
    background: 'rgba(0, 214, 143, 0.12)',
    border: 'rgba(0, 214, 143, 0.35)',
  };
};
